var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErodeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M34 17.4388C34 25.1782 29.0938 31.7094 22.3314 34C22.309 33.9651 22.2821 33.9321 22.2517 33.8999C20.9737 32.4898 19.2974 29.6235 22.5309 26.1973C29.1412 19.2098 21.8364 18.9142 18.1599 16.9669C13.6143 14.6093 19.1739 12.5437 21.1294 9.21564C23.084 5.88762 19.7485 6.4605 19.7485 6.4605C19.7485 6.4605 23.1046 6.82956 16.3395 10.8709C9.57442 14.9123 10.0738 19.0473 12.0105 20.0003C14.2891 21.1249 17.7885 22.1991 11.4315 27.2402C9.66839 28.6458 8.44317 30.3305 7.59295 31.9637C3.02232 28.8432 0 23.5128 0 17.4388C0 7.84128 7.64396 0 17 0C26.356 0 34 7.84128 34 17.4388Z",
    fill: "#A2BBBF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErodeIcon);
export default __webpack_public_path__ + "static/media/erode_icon.922522a84bbef4ca3bef3bacac5fe0d2.svg";
export { ForwardRef as ReactComponent };